export default __webpack_public_path__ + "static/media/Roboki@2x.d6effaa5.png";